// extracted by mini-css-extract-plugin
export var animationContainer = "_gl-0";
export var asteriskIcon = "_gl-8";
export var conversationLeftSection = "_gl-4";
export var conversationListItem = "_gl-3";
export var conversationMiddleSection = "_gl-5";
export var conversationRightSection = "_gl-6";
export var detailsContent = "_gl-1";
export var listContainer = "_gl-7";
export var modalContent = "_gl-2";